import { render, staticRenderFns } from "./EmployeeNavigatorWidget.vue?vue&type=template&id=d24c42f2&scoped=true"
import script from "./EmployeeNavigatorWidget.vue?vue&type=script&lang=ts"
export * from "./EmployeeNavigatorWidget.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeNavigatorWidget.vue?vue&type=style&index=0&id=d24c42f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24c42f2",
  null
  
)

export default component.exports